import { ReactNode } from 'react';
import { HoverCard } from '@round/creatorbase-ui';
import styles from './ConfigurationHoverCard.module.css';

// Long enough that a pointer crossing the column on its way elsewhere does not open the card.
const HOVER_DELAY_MS = 200;

type Props = {
    summary: string;
    title: string;
    children: ReactNode;
};

/** A part of a request's setup, counted in the row and read in full on hover. */
export const ConfigurationHoverCard = ({ summary, title, children }: Props) => (
    <HoverCard>
        {/* A button rather than the default link: there is nowhere to navigate to, and it puts the
            setup within reach of a keyboard as well as a pointer. */}
        <HoverCard.Trigger delay={HOVER_DELAY_MS} render={<button type="button" />} className={styles.summary}>
            {summary}
        </HoverCard.Trigger>

        {/* The card is portalled out of the row, but React carries a click back up the tree it was
            rendered from — the row that opens the request. */}
        <HoverCard.Content className={styles.card} onClick={(event) => event.stopPropagation()}>
            <p className={styles.cardTitle}>{title}</p>
            {children}
        </HoverCard.Content>
    </HoverCard>
);
